import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import './AddButton.scss';

const AddButton = ({
  onClicked,
}) => (
  <div className="icon-container" onClick={onClicked}>
    <Icon icon="plus" size="3x" color="#fff" />
  </div>
);

AddButton.propTypes = {
  onClicked: PropTypes.func.isRequired,
};

export default AddButton;
